import { motion, AnimatePresence } from 'framer-motion';
import { X, MessageSquare } from 'lucide-react';

interface ChatbotAIModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ChatbotAIModal({ isOpen, onClose }: ChatbotAIModalProps) {
  if (!isOpen) return null;
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-pink-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-pink-500/30 shadow-2xl shadow-pink-500/20"
          >
            <div className="relative p-8 border-b border-pink-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl">
                    <MessageSquare className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-rose-400">
                      Chatbot AI - Vision
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">Un bot par app/section, 100% contextualisé</p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>
            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-pink-600/20 via-rose-600/20 to-pink-600/20 rounded-xl p-8 border-2 border-pink-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">Chatbot Standard</h3>
                <p className="text-gray-300 text-center text-lg">
                  <strong className="text-white">Un seul chatbot par app</strong>, toujours contextualisé (écran, objet, rôle).
                </p>
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-slate-800/50 rounded-lg p-4">
                  <h5 className="text-pink-400 font-bold mb-2">Modes</h5>
                  <ul className="text-gray-300 text-sm space-y-1">
                    <li>• ASK - Questions</li>
                    <li>• DO - Actions</li>
                    <li>• LEARN - Apprentissage</li>
                    <li>• ESCALATE - Escalade</li>
                  </ul>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-4">
                  <h5 className="text-rose-400 font-bold mb-2">KPI</h5>
                  <p className="text-gray-300 text-sm">CSAT bot ≥4/5</p>
                </div>
              </div>
            </div>
            <div className="p-6 border-t border-pink-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button onClick={onClose} className="px-6 py-3 bg-gradient-to-r from-pink-500 to-rose-500 text-white rounded-xl hover:from-pink-600 hover:to-rose-600 transition-all duration-200 font-semibold shadow-lg shadow-pink-500/20 hover:shadow-pink-500/40 hover:scale-105">
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

